export class AddInError extends Error {
  context?: Record<string, unknown>;

  constructor(message: string, context?: Record<string, unknown>) {
    super(message);
    this.name = 'AddInError';
    this.context = context;
    Object.setPrototypeOf(this, AddInError.prototype);
  }
}
